export const tableColumns = [
  {
    label: "看板名称",
    value: "name"
  },
  {
    label: "看板描述",
    value: "desc"
  },
  {
    label: "最后修改人",
    value: "updateUser.name"
  },
  {
    label: "最后修改时间",
    value: "updateAt"
  },
  {
    label: "创建人",
    value: "creator.name"
  },
  {
    label: "创建时间",
    value: "createAt"
  }
]

export const componentList = [
  {
    label: "图表",
    value: "figure",
    options: [
      {
        icon: "histogram",
        label: "柱状图",
        value: "basic-bar"
      },
      {
        icon: "stack-basic",
        label: "堆叠柱",
        value: "stacked-basic-bar"
      },
      {
        icon: "bar",
        label: "条形图",
        value: "bar"
      },
      {
        icon: "stack-bar",
        label: "堆叠条",
        value: "stacked-bar"
      },
      {
        icon: "line-chart",
        label: "折线图",
        value: "line"
      },
      {
        icon: "graph",
        label: "曲线图",
        value: "smoothed-line"
      },
      {
        icon: "area-chart",
        label: "面积图",
        value: "area-chart"
      },
      {
        icon: "ring-diagram",
        label: "环形图",
        value: "ring-diagram"
      },
      {
        icon: "pie-chart",
        label: "饼图",
        value: "pie"
      },
      {
        icon: "indicator-card",
        label: "指标卡",
        value: "indicator"
      },
      {
        icon: "funnel-chart",
        label: "漏斗图",
        value: "funnel"
      },
      {
        icon: "pivot-table",
        label: "交叉表",
        value: "cross-table"
      },
      {
        icon: "map",
        label: "地图",
        value: "map"
      }
    ]
  },
  {
    label: "图文",
    value: "article",
    options: [
      {
        icon: "rich",
        label: "富文本",
        value: "rich"
      },
      {
        icon: "image",
        label: "图片",
        value: "image"
      }
    ]
  },
  {
    label: "其他",
    value: "other",
    options: [
      {
        icon: "query",
        label: "查询",
        value: "query"
      },
      { icon: "view", label: "视图", value: "view" }
    ]
  }
]

export const boardMenus = [
  {
    name: "全局"
  },
  {
    name: "组件"
  },
  {
    name: "移动端"
  }
]

export const graphs = [
  {
    icon: "histogram",
    label: "柱状图",
    value: "basic-bar"
  },
  {
    icon: "bar",
    label: "条形图",
    value: "bar"
  },
  {
    icon: "line-chart",
    label: "折线图",
    value: "line"
  },
  {
    icon: "graph",
    label: "曲线图",
    value: "smoothed-line"
  },
  {
    icon: "pie-chart",
    label: "饼图",
    value: "pie"
  },
  {
    icon: "indicator-card",
    label: "指标卡",
    value: "indicator"
  }
]

export const operation = [
  { title: "复制", command: "copyFigure" },
  { title: "删除", command: "deleteFigure" }
]

export const queryOperation = [
  { title: "复制", command: "copyQuery" },
  { title: "删除", command: "deleteQuery" }
]

export const richOperation = [
  { title: "复制", command: "copyRich" },
  { title: "删除", command: "deleteRich" }
]

export const viewOperation = [
  { title: "复制", command: "copyView" },
  { title: "删除", command: "deleteView" }
]

export const imageOperation = [
  { title: "复制", command: "copyImage" },
  { title: "删除", command: "deleteImage" }
]

export const optionTypes = [
  {
    label: "前....年",
    value: "year-ago",
    type: "年"
  },
  {
    label: "前....月",
    value: "month-ago",
    type: "月"
  },
  {
    label: "前....日",
    value: "day-ago",
    type: "日"
  },
  {
    label: "后....年",
    value: "year-after",
    type: "年"
  },
  {
    label: "后....月",
    value: "month-after",
    type: "月"
  },
  {
    label: "后....日",
    value: "day-after",
    type: "日"
  }
]

export const compareMethodMap = {
  equal: "等于",
  begin: "大于等于",
  end: "小于等于"
}

export const commonFields = ["name", "dataKind", "type", "charts"]

export const fieldNameMap = {
  name: "条件名称",
  type: "条件类型",
  charts: "关联设置",
  timeType: "时间类型",
  regionType: "区间类型",
  regions: "区间设置",
  defaultVal: "默认值",
  oneFlag: "选择类型"
}

export const storylineFieldNameMap = {
  name: "节点名称",
  chartId: "关联图表"
}

export const selectTypes = ["option", "staff", "department", "company", "area", "rate"]

export const textTypes = ["text", "sn", "telephone", "mail"]

export const numTypes = ["number", "money", "calc", "gather"]

export const textCompareMethods = ["包含", "开头是", "结尾是", "是", "不是", "不包含"]
export const numCompareMethods = ["大于", "等于", "小于"]

export const conditionTypes = [
  {
    label: "日期时间",
    value: "time"
  },
  {
    label: "选择",
    value: "option"
  },
  {
    label: "人员",
    value: "staff"
  },
  {
    label: "部门",
    value: "department"
  },
  {
    label: "企业",
    value: "company"
  },
  {
    label: "等级",
    value: "rate"
  },
  {
    label: "文本框",
    value: "text"
  },
  {
    label: "自动编码",
    value: "sn"
  },
  {
    label: "手机号",
    value: "telephone"
  },
  {
    label: "邮箱",
    value: "mail"
  },
  {
    label: "数值",
    value: "number"
  },
  {
    label: "金额",
    value: "money"
  },
  {
    label: "计算",
    value: "calc"
  },
  {
    label: "汇总",
    value: "gather"
  },
  {
    label: "地区",
    value: "area"
  }
]

export const dataKinds = [
  {
    label: "原数据",
    value: "raw-data"
  },
  {
    label: "指标",
    value: "quota"
  }
]

export const regionTypes = [
  {
    label: "自定义",
    value: "自定义",
    type: "年"
  },
  {
    label: "今天",
    value: "this-day",
    type: "时"
  },
  {
    label: "昨天",
    value: "last-day",
    type: "时"
  },
  {
    label: "明天",
    value: "next-day",
    type: "时"
  },
  {
    label: "本周",
    value: "this-week",
    type: "日"
  },
  {
    label: "上周",
    value: "last-week",
    type: "日"
  },
  {
    label: "下周",
    value: "next-week",
    type: "日"
  },
  {
    label: "本月",
    value: "this-month",
    type: "日"
  },
  {
    label: "上月",
    value: "last-month",
    type: "日"
  },
  {
    label: "下月",
    value: "next-month",
    type: "日"
  },
  {
    label: "本季度",
    value: "this-quarter",
    type: "月"
  },
  {
    label: "上季度",
    value: "last-quarter",
    type: "月"
  },
  {
    label: "下季度",
    value: "next-quarter",
    type: "月"
  },
  {
    label: "本年度",
    value: "this-year",
    type: "月"
  },
  {
    label: "上年度",
    value: "last-year",
    type: "月"
  },
  {
    label: "下年度",
    value: "next-year",
    type: "月"
  }
]

export const boardIcons = [
  "icon-20",
  "default-icon",
  "icon-01",
  "icon-02",
  "icon-03",
  "icon-04",
  "icon-05",
  "icon-06",
  "icon-07",
  "icon-08",
  "icon-09",
  "icon-10",
  "icon-11",
  "icon-12",
  "icon-13",
  "icon-14",
  "icon-15",
  "icon-16",
  "icon-17",
  "icon-18",
  "icon-19",
  // "icon-20",
  "icon-21",
  "icon-22",
  "icon-23",
  "icon-24",
  "icon-25",
  "icon-26",
  "icon-27",
  "icon-28",
  "icon-29",
  "icon-30",
  "icon-31",
  "icon-32",
  "icon-33",
  "icon-34",
  "icon-35",
  "icon-36",
  "icon-37",
  "icon-38",
  "icon-39",
  "icon-40",
  "icon-41",
  "icon-42",
  "icon-43",
  "icon-44",
  "icon-45",
  "icon-46",
  "icon-47",
  "icon-48",
  "icon-49",
  "icon-50",
  "icon-51",
  "icon-52",
  "icon-53",
  "icon-54",
  "icon-55",
  "icon-56",
  "icon-57",
  "icon-58",
  "icon-59"
]

export const boardColors = ["#FDAF5A", "#1989FA", "#BA67FF"]

export const themeList = [
  {
    name: "walden",
    backgroundColor: "rgba(252, 252, 252, 0)",
    children: ["rgb(63, 177, 227)", "rgb(107, 230, 193)", "rgb(98, 108, 145)", "rgb(160, 167, 230)"]
  },
  {
    name: "vintage",
    backgroundColor: "rgb(254, 248, 239)",
    children: [
      "rgb(216, 124, 124)",
      "rgb(145, 158, 139)",
      "rgb(215, 171, 130)",
      "rgb(110, 112, 116)"
    ]
  },
  {
    name: "dark",
    backgroundColor: "rgb(51, 51, 51)",
    children: [
      "rgb(221, 107, 102)",
      "rgb(117, 154, 160)",
      "rgb(230, 157, 135)",
      "rgb(141, 193, 169)"
    ]
  },
  {
    name: "westeros",
    backgroundColor: "transparent",
    children: ["rgb(81, 107, 145)", "rgb(89, 196, 230)", "rgb(237, 175, 218)", "rgb(147, 183, 227)"]
  },
  {
    name: "essos",
    backgroundColor: "#FFFAF0",
    children: ["rgb(137, 52, 72)", "rgb(217, 88, 80)", "rgb(235, 129, 70)", "rgb(255, 178, 72)"]
  },
  {
    name: "wonderland",
    backgroundColor: "transparent",
    children: ["rgb(78, 163, 151)", "rgb(34, 195, 170)", "rgb(123, 217, 165)", "rgb(208, 100, 138)"]
  },
  {
    name: "chalk",
    backgroundColor: "rgb(41, 52, 65)",
    children: [
      "rgb(252, 151, 175)",
      "rgb(135, 247, 207)",
      "rgb(247, 244, 148)",
      "rgb(114, 204, 255)"
    ]
  },
  {
    name: "infographic",
    backgroundColor: "transparent",
    children: ["rgb(193, 35, 43)", "rgb(39, 114, 123)", "rgb(252, 206, 16)", "rgb(232, 124, 37)"]
  },
  {
    name: "macarons",
    backgroundColor: "transparent",
    children: ["rgb(46, 199, 201)", "rgb(182, 162, 222)", "rgb(90, 177, 239)", "rgb(255, 185, 128)"]
  },
  {
    name: "roma",
    backgroundColor: "transparent",
    children: ["rgb(224, 31, 84)", "rgb(0, 24, 82)", "rgb(245, 232, 200)", "rgb(184, 210, 199)"]
  },
  {
    name: "shine",
    backgroundColor: "transparent",
    children: ["rgb(193, 46, 52)", "rgb(230, 182, 0)", "rgb(0, 152, 217)", "rgb(43, 130, 29)"]
  },
  {
    name: "purple-passion",
    backgroundColor: "rgb(91, 92, 110)",
    children: [
      "rgb(138, 124, 168)",
      "rgb(224, 152, 199)",
      "rgb(143, 211, 232)",
      "rgb(113, 102, 158)"
    ]
  }
]
